import React from "react";
import "./Synonym.css";

export default function Synonyms(props) {
  if (props.synonyms && props.synonyms.length > 0) {
    return (
      <div className="synonyms-wrapper d-flex flex-wrap align-items-center gap-2">
        <span className="synonym-label">Synonyms</span>
        {props.synonyms.map(function (synonym, index) {
          return <span key={index} className="synonym-badge">{synonym} </span>;
        })}
      </div>
    );
  } else {
    return null;
  }
}